import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"

export const branch_office_variation_form_template = {
    branchOffice: '',
}

export const branch_office_variation_form_validators = {
    branchOffice: [Validators.required, Validators.pattern(/^\d{5}$/)]
}

export const branch_office_variation_form_keys: IFormKey[] = [
    {
        id: 'branch-office-field',
        label: 'Nuova filiale',
        controlName: 'branchOffice',
        css: 'col-8',
        type: 'INPUT'
    }
];

export interface IBranchOfficeChangeRequest {
    policyNumber: string;
    nuovoCab: string;
}